<template>
  <RevInfoBlock
    :title="i18n(translations.label)"
    variant="info"
    :caption="warrantyCaption"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { BackmarketWarranty } from '@backmarket/http-api/src/api-models/BackmarketWarranty'
import type { MerchantWarranty } from '@backmarket/http-api/src/api-models/MerchantWarranty'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInfoBlock } from '@ds/components/InfoBlock'

import translations from './DefectWarrantyInfoBlock.translations'

const i18n = useI18n()

const props = defineProps<{
  backmarketWarranty: BackmarketWarranty | null
  merchantWarranty: MerchantWarranty
}>()

const defectWarranty = computed(() => {
  if (
    props.backmarketWarranty &&
    props.backmarketWarranty.duration > props.merchantWarranty.duration
  ) {
    return props.backmarketWarranty
  }

  return props.merchantWarranty
})

const warrantyCaption = computed(() => {
  return `${i18n(translations.coveredUntil, {
    date: new Date(defectWarranty.value.endDate),
  })} - ${i18n(translations.free)}`
})
</script>
